(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2995],{

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 3011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54076);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70710);










const FaqComponent = (props)=>{
    const { 0: isViewMore , 1: setIsViewMore  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: showCardDetail , 1: setShowCardDetail  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().faqComponent),
        style: {
            backgroundColor: props.sectionBgColor || "#EFEFFA"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-center",
                                    children: props.title
                                }),
                                props.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    children: props.description
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: props.subTitle1
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: props.subTitle2
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: props.subTitle3
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                            children: props.faqPoints?.length > 0 && props.faqPoints.map((faqsdata, index)=>{
                                const condition = !isViewMore ? index < 5 : index >= 0;
                                const key = index.toString();
                                return condition && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    xl: 8,
                                    lg: 8,
                                    md: 8,
                                    sm: 8,
                                    xs: 8,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        activeKey: showCardDetail,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stuAccordion),
                                            eventKey: key,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Header */ .Z.Header, {
                                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accoHead),
                                                    onClick: ()=>{
                                                        if (showCardDetail === key) {
                                                            setShowCardDetail(null);
                                                        } else {
                                                            setShowCardDetail(key);
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            style: {
                                                                color: ` ${showCardDetail === key ? "#0c63e4" : "#201f22"}`
                                                            },
                                                            children: [
                                                                " ",
                                                                faqsdata.title
                                                            ]
                                                        }),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accorBody),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: faqsdata.description
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, index);
                            })
                        }),
                        props.faqPoints?.length > 5 && !isViewMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-4 mb-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    id: "faq-component",
                                    onClick: ()=>{
                                        setIsViewMore(true);
                                    },
                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().viewMore),
                                    children: "View More"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqComponent);


/***/ }),

/***/ 79767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Tab__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73192);
/* harmony import */ var react_bootstrap_Tabs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85509);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78182);
/* harmony import */ var _styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58088);
/* harmony import */ var _styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(13540);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40607);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45992);














const Recognition = ({ bgColor  })=>{
    const { 0: selectedImage , 1: setSelectedImage  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { 0: recognitions , 1: setRecognitions  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(`${"https://cms.studies-overseas.com"}/recognitions`, "GET", {}, "", false).then((res)=>setRecognitions(res.recognitions));
    }, []);
    const sliderRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    const settings = {
        dotsClass: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().sliderDots),
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const cardsRender = (certificates, index)=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    ...settings,
                    ref: (slider)=>sliderRefs.current[index] = slider,
                    className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().slider),
                    children: certificates.map((certificate)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "regi-slider-div",
                            className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().regiSliderDiv),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cardCustRecog),
                                onClick: ()=>setSelectedImage(certificate.certificateUrl),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Body */ .Z.Body, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().logoContainer),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: certificate.logoUrl,
                                                alt: certificate.logoAltTag,
                                                width: 200,
                                                height: 140
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Title */ .Z.Title, {
                                            className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().titleHeight),
                                            children: certificate.logoName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            src: "/new-images/starrecog.svg",
                                            width: 70,
                                            height: 20,
                                            className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().startRegImg),
                                            alt: "starrecog"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().titleBlue),
                                            children: certificate.certificateName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().dateText),
                                            children: certificate.yearField
                                        }),
                                        certificate?.link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: certificate?.link,
                                            target: "_blank",
                                            className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().link),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                children: [
                                                    "Visit ",
                                                    certificate?.linkText,
                                                    " Website"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        });
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: "arrowsid",
                    className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().arrowsClass),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btcircle),
                            onClick: ()=>sliderRefs?.current?.[index]?.slickPrev(),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                src: "/new-images/left-arrow.svg",
                                height: 17,
                                width: 10,
                                alt: "left-arrow"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btcircle),
                            onClick: ()=>sliderRefs?.current?.[index]?.slickNext(),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                src: "/new-images/right-arrow.svg",
                                height: 17,
                                width: 10,
                                alt: "right-arrow"
                            })
                        })
                    ]
                })
            ]
        });
    };
    const controlledTabs = ()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Tabs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            id: "certficate-recog",
            unmountOnExit: true,
            defaultActiveKey: recognitions[0].title,
            className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().recogTabs),
            style: {
                backgroundColor: bgColor
            },
            children: recognitions.map((recog, index)=>{
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Tab__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    eventKey: recog.title,
                    title: recog.title,
                    className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().custtab),
                    children: recog?.certificates?.length > 0 && cardsRender(recog.certificates, index)
                });
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            recognitions.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "recongnition",
                className: (_styles_Recognition_module_scss__WEBPACK_IMPORTED_MODULE_7___default().recongnition),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    style: {
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: "Recognitions"
                            })
                        }),
                        controlledTabs()
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                "aria-labelledby": "contained-modal-title-vcenter",
                centered: true,
                show: selectedImage ? true : false,
                onHide: ()=>setSelectedImage(""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Body */ .Z.Body, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        src: selectedImage || "/",
                        alt: selectedImage || "",
                        width: 500,
                        height: 650
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Recognition);


/***/ }),

/***/ 58088:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"recongnition":"Recognition_recongnition__AGK6e","recogTg":"Recognition_recogTg__cuLwm","recogMob":"Recognition_recogMob__xdbfa","titleHeight":"Recognition_titleHeight__WnTrU","regiSliderDiv":"Recognition_regiSliderDiv__7TEtm","sliderDots":"Recognition_sliderDots__rp2ei","contcatMainCard":"Recognition_contcatMainCard__FNVfQ","card":"Recognition_card__H3muO","contactCard":"Recognition_contactCard__nNfny","icon":"Recognition_icon__IRfQA","recogTabs":"Recognition_recogTabs__RcaZU","active":"Recognition_active__4XC6f","viewMore":"Recognition_viewMore__4WTvE","cardCustRecog":"Recognition_cardCustRecog__9aa4K","logoContainer":"Recognition_logoContainer__IMUKN","titleBlue":"Recognition_titleBlue__kWCBp","dateText":"Recognition_dateText___vBJw","card-title":"Recognition_card-title__3d2In","link":"Recognition_link__UV7Lm","arrowsClass":"Recognition_arrowsClass__b6xHe","btcircle":"Recognition_btcircle___tPe3"};

/***/ }),

/***/ 42547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"pstlandingpage_banner__g_UPf","nav":"pstlandingpage_nav__QrKZh","navLogo":"pstlandingpage_navLogo__rYw7Z","maincontent":"pstlandingpage_maincontent__tcl1X","fairdetails":"pstlandingpage_fairdetails___3Awg","heading":"pstlandingpage_heading__CmSZI","ulli":"pstlandingpage_ulli__fqPBp","liItem":"pstlandingpage_liItem__kE_QJ","regBtn":"pstlandingpage_regBtn__SXSXv","reg":"pstlandingpage_reg__808jO","enq":"pstlandingpage_enq__YbXM2","btnReg":"pstlandingpage_btnReg__ifx_Y","bannerStudDiv":"pstlandingpage_bannerStudDiv__h0Iis","bg":"pstlandingpage_bg__EOIvU","WhyKc":"pstlandingpage_WhyKc__aTj1F","viewMore":"pstlandingpage_viewMore__57U7q","whyMb":"pstlandingpage_whyMb__E2tnD","bussiness":"pstlandingpage_bussiness__8M5jS","uni":"pstlandingpage_uni__iGGja","img":"pstlandingpage_img__zoQjU","logo":"pstlandingpage_logo__PhEVL","sliderdiv":"pstlandingpage_sliderdiv__WSqCW","capabilityBg":"pstlandingpage_capabilityBg__e8FfP","content":"pstlandingpage_content__Lr07i","subcontent":"pstlandingpage_subcontent__bduG9","imgRow":"pstlandingpage_imgRow__5PEei","steps":"pstlandingpage_steps__uo121","points":"pstlandingpage_points__Qc5ZJ","mainbox":"pstlandingpage_mainbox__2nHev","boximg":"pstlandingpage_boximg___iqhq","association":"pstlandingpage_association__KcsWN","custCard":"pstlandingpage_custCard__2dOTw","imgDiv":"pstlandingpage_imgDiv__zKq9h","cardBody":"pstlandingpage_cardBody__5VPch","mainDiv":"pstlandingpage_mainDiv__E_si7","div":"pstlandingpage_div__12NSx","footer":"pstlandingpage_footer__UMKA1","footerlogo":"pstlandingpage_footerlogo__r5ngN","activeClass":"pstlandingpage_activeClass__XLLQe","arrowsClass":"pstlandingpage_arrowsClass___Haw3","btcircle":"pstlandingpage_btcircle__Sy1vj","sliderDots":"pstlandingpage_sliderDots__f2brx","elanLoansComp":"pstlandingpage_elanLoansComp__Xu5qO","elanContent":"pstlandingpage_elanContent__a4FxP","elanSubheading":"pstlandingpage_elanSubheading__MZ9zo","slider":"pstlandingpage_slider__ux_j6","imageDiv":"pstlandingpage_imageDiv__zXYkn","countryName":"pstlandingpage_countryName__y5U_f","button":"pstlandingpage_button__Hj8FU","enquirebtn":"pstlandingpage_enquirebtn__HXtlR","achievements":"pstlandingpage_achievements__4uMWW","description":"pstlandingpage_description__9Po_q","containerDiv":"pstlandingpage_containerDiv__1iO_z","sliderContainer":"pstlandingpage_sliderContainer__BD5UY","achievementsDiv":"pstlandingpage_achievementsDiv__gDUMc","icon":"pstlandingpage_icon__6cN3s","studVideo":"pstlandingpage_studVideo__57n8X","videoDiv":"pstlandingpage_videoDiv__gcrFA","videos":"pstlandingpage_videos__mNRB3","faqComponent":"pstlandingpage_faqComponent__DG96z","box":"pstlandingpage_box__dSteF","stuAccordion":"pstlandingpage_stuAccordion__0Carb","accoHead":"pstlandingpage_accoHead__5gc_W","card":"pstlandingpage_card___j1YG","cardImgDiv":"pstlandingpage_cardImgDiv__ANALH","cardImg":"pstlandingpage_cardImg__n_32_","caption":"pstlandingpage_caption___TAdQ","caption2":"pstlandingpage_caption2__V6haF","localeButton":"pstlandingpage_localeButton__N8bhp","selectClass":"pstlandingpage_selectClass__l1KDY"};

/***/ }),

/***/ 54076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(91505);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(23594);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/transitionEndListener.js
var transitionEndListener = __webpack_require__(93825);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction(...funcs) {
  return funcs.filter(f => f != null).reduce((acc, f) => {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction(...args) {
      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var esm_createChainedFunction = (createChainedFunction);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/triggerBrowserReflow.js
var triggerBrowserReflow = __webpack_require__(34509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/TransitionWrapper.js
var TransitionWrapper = __webpack_require__(9337);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Collapse.js









const MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDefaultDimensionValue(dimension, elem) {
  const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
  const value = elem[offset];
  const margins = MARGINS[dimension];
  return value + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[0]), 10) + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[1]), 10);
}

const collapseStyles = {
  [Transition/* EXITED */.Wj]: 'collapse',
  [Transition/* EXITING */.Ix]: 'collapsing',
  [Transition/* ENTERING */.d0]: 'collapsing',
  [Transition/* ENTERED */.cn]: 'collapse show'
};
const defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  getDimensionValue: getDefaultDimensionValue
};
const Collapse = /*#__PURE__*/react.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  className,
  children,
  dimension = 'height',
  getDimensionValue = getDefaultDimensionValue,
  ...props
}, ref) => {
  /* Compute dimension */
  const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
  /* -- Expanding -- */

  const handleEnter = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = '0';
  }, onEnter), [computedDimension, onEnter]);
  const handleEntering = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
    elem.style[computedDimension] = `${elem[scroll]}px`;
  }, onEntering), [computedDimension, onEntering]);
  const handleEntered = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onEntered), [computedDimension, onEntered]);
  /* -- Collapsing -- */

  const handleExit = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
    (0,triggerBrowserReflow/* default */.Z)(elem);
  }, onExit), [onExit, getDimensionValue, computedDimension]);
  const handleExiting = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onExiting), [computedDimension, onExiting]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionWrapper/* default */.Z, {
    ref: ref,
    addEndListener: transitionEndListener/* default */.Z,
    ...props,
    "aria-expanded": props.role ? props.in : null,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting,
    childRef: children.ref,
    children: (state, innerProps) => /*#__PURE__*/react.cloneElement(children, { ...innerProps,
      className: classnames_default()(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
    })
  });
}); // @ts-ignore

// @ts-ignore
Collapse.defaultProps = defaultProps;
/* harmony default export */ var esm_Collapse = (Collapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/react.createContext({});
context.displayName = 'AccordionContext';
/* harmony default export */ var AccordionContext = (context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js







const AccordionCollapse = /*#__PURE__*/react.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Collapse, {
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey),
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: react.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItemContext.js

const AccordionItemContext_context = /*#__PURE__*/react.createContext({
  eventKey: ''
});
AccordionItemContext_context.displayName = 'AccordionItemContext';
/* harmony default export */ var AccordionItemContext = (AccordionItemContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionBody.js







const AccordionBody = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionCollapse, {
    eventKey: eventKey,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';
/* harmony default export */ var esm_AccordionBody = (AccordionBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js







function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = (0,react.useContext)(AccordionContext);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;

    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }

    onSelect == null ? void 0 : onSelect(eventKeyPassed, e);
    onClick == null ? void 0 : onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": eventKey === activeEventKey,
    className: classnames_default()(className, bsPrefix, !isAccordionItemSelected(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';
/* harmony default export */ var esm_AccordionButton = (AccordionButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionHeader.js





const AccordionHeader = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionButton, {
      onClick: onClick,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';
/* harmony default export */ var esm_AccordionHeader = (AccordionHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItem.js






const AccordionItem = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-item');
  const contextValue = (0,react.useMemo)(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionItemContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';
/* harmony default export */ var esm_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js












const Accordion = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion');
  const contextValue = (0,react.useMemo)(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...controlledProps,
      className: classnames_default()(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
/* harmony default export */ var esm_Accordion = (Object.assign(Accordion, {
  Button: esm_AccordionButton,
  Collapse: esm_AccordionCollapse,
  Item: esm_AccordionItem,
  Header: esm_AccordionHeader,
  Body: esm_AccordionBody
}));

/***/ }),

/***/ 85509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var uncontrollable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47150);
/* harmony import */ var _restart_ui_Tabs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83916);
/* harmony import */ var _Nav__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80957);
/* harmony import */ var _NavLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14691);
/* harmony import */ var _NavItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41244);
/* harmony import */ var _TabContent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28752);
/* harmony import */ var _TabPane__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75103);
/* harmony import */ var _ElementChildren__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53439);
/* harmony import */ var _getTabTransitionComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96101);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);












const defaultProps = {
  variant: 'tabs',
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  let defaultActiveKey;
  (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .forEach */ .Ed)(children, child => {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

function renderTab(child) {
  const {
    title,
    eventKey,
    disabled,
    tabClassName,
    tabAttrs,
    id
  } = child.props;

  if (title == null) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_NavItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    as: "li",
    role: "presentation",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_NavLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      as: "button",
      type: "button",
      eventKey: eventKey,
      disabled: disabled,
      id: id,
      className: tabClassName,
      ...tabAttrs,
      children: title
    })
  });
}

const Tabs = props => {
  const {
    id,
    onSelect,
    transition,
    mountOnEnter,
    unmountOnExit,
    children,
    activeKey = getDefaultActiveKey(children),
    ...controlledProps
  } = (0,uncontrollable__WEBPACK_IMPORTED_MODULE_1__/* .useUncontrolled */ .Ch)(props, {
    activeKey: 'onSelect'
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_restart_ui_Tabs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    id: id,
    activeKey: activeKey,
    onSelect: onSelect,
    transition: (0,_getTabTransitionComponent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(transition),
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Nav__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { ...controlledProps,
      role: "tablist",
      as: "ul",
      children: (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(children, renderTab)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TabContent__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      children: (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(children, child => {
        const childProps = { ...child.props
        };
        delete childProps.title;
        delete childProps.disabled;
        delete childProps.tabClassName;
        delete childProps.tabAttrs;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TabPane__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { ...childProps
        });
      })
    })]
  });
};

Tabs.defaultProps = defaultProps;
Tabs.displayName = 'Tabs';
/* harmony default export */ __webpack_exports__["Z"] = (Tabs);

/***/ })

}]);